module.exports = __webpack_public_path__ + "media/images/bola-de-futebol-b825b0a16faa7f5c149181e843965b30.png";